import { render } from "./CommonForm.vue?vue&type=template&id=17a752ce&scoped=true"
import script from "./CommonForm.vue?vue&type=script&lang=js"
export * from "./CommonForm.vue?vue&type=script&lang=js"

import "./CommonForm.vue?vue&type=style&index=0&id=17a752ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a752ce"]])

export default __exports__